import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { startCheckout } from '../lib/shopify';
export function Nav() {
  const [loading, setLoading] = useState(false);
  const handleBuy = async () => {
    setLoading(true);
    await startCheckout();
  };
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 mt-[36px] ${scrolled ? 'bg-black/80 backdrop-blur-md border-b border-white/5 py-3' : 'bg-transparent py-5'}`} data-id="element-242">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-243">
        <a href="#" className="flex items-center gap-2" data-id="element-244">
          <img src="https://cdn.magicpatterns.com/uploads/hMbwXN9QFw6Y833Vj9bN6y/LOGO_ELEMENTAL_NEW.png" alt="Elemental Shop" className="h-9 md:h-10 w-auto brightness-0 invert" data-id="element-245" />
        </a>

        <div className="hidden md:flex items-center gap-8 text-sm font-semibold text-muted" data-id="element-246">
          <a href="#whats-inside" className="hover:text-offwhite transition-colors" data-id="element-247">
            What's Inside
          </a>
          <a href="#bonuses" className="hover:text-offwhite transition-colors" data-id="element-248">
            Bonuses
          </a>
          <a href="#reviews" className="hover:text-offwhite transition-colors" data-id="element-249">
            Reviews
          </a>
        </div>

        <button onClick={handleBuy} disabled={loading} className="bg-gold text-black px-6 py-2.5 rounded-full text-sm font-bold hover:bg-gold-light transition-colors shadow-[0_0_15px_rgba(201,169,97,0.3)] disabled:opacity-70 disabled:cursor-wait" data-id="element-250">
          {loading ? 'Loading…' : 'Get Access'}
        </button>
      </div>
    </motion.nav>;
}